<template>
    <div class="home__container">
        <LoadingScreen v-if="isLoadingScreen"></LoadingScreen>
        <template v-else>
            <div class="home__logo">
                <img
                    class="home__logo--logo"
                    src="~ThemePath/images/logo3.png"
                />
                <div class="home__version">
                    {{
                        getTranslatedText(`version ${$store.state.versionApp}`)
                    }}
                </div>
            </div>
            <div class="home__title">
                {{ getTranslatedText("dashboard") }}
            </div>
            <div class="home__items__container">
                <template v-if="!$store.state.isOnlyPaument">
                    <div
                        v-show="$store.state.isShowSports"
                        @click="$router.push('/sports')"
                        class="home__item home__item__sport"
                    >
                        <img src="~ThemePath/images/sports.png" />
                        <div class="home__item__title">
                            {{ getTranslatedText("bitville-sports") }}
                        </div>
                    </div>
                    <div
                        v-show="$store.state.isShow590"
                        @click="onOpenLoto('/loto', 1)"
                        class="home__item home__item__sport"
                    >
                        <img src="~ThemePath/images/lotteries.png" />
                        <div class="home__item__title">
                            {{ getTranslatedText("Loto 5/90") }}
                        </div>
                    </div>
                    <div
                        v-show="$store.state.isShow645"
                        @click="onOpenLoto('/loto-645', 2)"
                        class="home__item home__item__sport"
                    >
                        <img src="~ThemePath/images/lotteries.png" />
                        <div class="home__item__title">
                            {{ getTranslatedText("Loto 6/45") }}
                        </div>
                    </div>
                </template>
                <div class="home__item home__item__voucher" @click="onOpenLoto('/voucher')">
                        <img src="~ThemePath/images/voucher.png" />
                        <div class="home__item__title">
                            {{ getTranslatedText('vouchers') }}
                        </div>
                    </div>
                <div
                    class="home__item home__item__history"
                    @click="$router.push('/history')"
                >
                    <img src="~ThemePath/images/report.png" />
                    <div class="home__item__title">
                        {{ getTranslatedText("HISTORY") }}
                    </div>
                </div>
                <div
                    @click="$router.push('/scan-ticket')"
                    class="home__item home__item__scan"
                >
                    <img src="~ThemePath/images/scan.png" />
                    <div class="home__item__title">
                        {{ getTranslatedText("scan") }}
                    </div>
                </div>
                <div @click="$router.push('/report')" class="home__items">
                    <div class="home__items__item home__items__item__left">
                        <img src="~ThemePath/images/report.png" />
                        <div class="home__item__title">
                            {{ getTranslatedText("report") }}
                        </div>
                    </div>
                    <div
                        @click="$router.push('/report-final')"
                        class="home__items__item"
                    >
                        <img src="~ThemePath/images/report.png" />
                        <div class="home__item__title">
                            {{ getTranslatedText("report final") }}
                        </div>
                    </div>
                </div>
                <div
                    v-show="$store.state.isShow645 || $store.state.isShow590"
                    @click="$router.push('/results')"
                    class="home__item home__item__result"
                >
                    <img src="~ThemePath/images/result.png" />
                    <div class="home__item__title">
                        {{ getTranslatedText("result") }}
                    </div>
                </div>
                <div
                    v-if="$store.state.isShow645 || $store.state.isShow590"
                    class="home__items home__items__2"
                >
                    <div
                        @click="$router.push('/about')"
                        class="home__items__item home__items__item__left-2"
                    >
                        <img src="~ThemePath/images/about.png" />
                        <div class="home__item__title">
                            {{ getTranslatedText("about") }}
                        </div>
                    </div>
                    <div
                        @click="$router.push('/print')"
                        class="home__items__item home__items__item__right-2"
                    >
                        <img src="~ThemePath/images/print.png" />
                        <div class="home__item__title">
                            {{ getTranslatedText("print") }}
                        </div>
                    </div>
                </div>
                <div
                    v-else
                    @click="$router.push('/print')"
                    class="home__item home__item__print"
                >
                    <img src="~ThemePath/images/print.png" />
                    <div class="home__item__title">
                        {{ getTranslatedText("print") }}
                    </div>
                </div>
                <div
                    @click="$router.push('/print')"
                    class="home__items home__items__3"
                >
                    <div class="home__items__item">
                        <div
                            @click="$router.push('/change-pin')"
                            class="home__item__title"
                        >
                            {{ getTranslatedText("Change PIN") }}
                        </div>
                    </div>
                    <div class="home__items__item" @click="handleLogout">
                        <div class="home__item__title">
                            {{ getTranslatedText("logout") }}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins";
import AuthService from "@/services/auth.service";
import settingService from "@/services/setting.service";
import LoadingScreen from "@/components/common/loading/index.vue";

import { isStrEmpty, setSettingSite } from "@/utils/utils";
const ACCOUNT = process.env.VUE_APP_ACCOUNT;
const IS_DEBUG = process.env.VUE_APP_IS_DEBUG;

export default {
    mixins: [languageMixins],
    components: { LoadingScreen },
    data() {
        return {
            ACCOUNT: ACCOUNT,
            IS_DEBUG: IS_DEBUG,
            isLoadingScreen: true,
        };
    },
    created() {
        this.fetchSetting();
    },
    methods: {
        async fetchSetting() {
            this.isLoadingScreen = true;
            try {
                let setting = await settingService.fetchSetting();
                this.$store.state.isOnlyPaument = isStrEmpty(
                    setting.burundi?.enabled_game_slugs
                );
                this.$store.state.isShow645 =
                    setting.burundi?.enabled_game_slugs?.indexOf(
                        "lotto-6-45"
                    ) !== -1;
                this.$store.state.isShow590 =
                    setting.burundi?.enabled_game_slugs?.indexOf(
                        "lotto-5-90"
                    ) !== -1;
                this.$store.state.isShowSports =
                    setting.burundi?.enabled_game_slugs?.indexOf(
                        "bitville-sports"
                    ) !== -1;

                this.$store.state.isShowVoucher = setting.burundi?.enabled_game_slugs?.indexOf('ludwin-prepaid-voucher') !== -1

                setSettingSite(setting);
                this.isLoadingScreen = false;
            } catch (error) {
                console.log(error);
            }
        },
        async handleLogout() {
            try {
                await AuthService.logout();
                this.$router.push("/login");
            } catch (error) {
                console.log(error);
            }
        },
        onOpenLoto(name, number) {
            this.$store.state.stepCart = parseInt(number);
            this.$router.push(name);
        },
    },
};
</script>
<style lang="scss">
@import "~ThemePath/scss/home/_index.scss";
</style>
